import {mergeDeepObject} from "./_util";
import {loadLib} from "../../../frontend/js/project/src/utils/loadLib";

const VGMask = {
	init: async function () {
		console.log('init')
		let _this = this,
			$selector = document.querySelectorAll('[data-mask]');

		if (!$selector.length) {
			return;
		}

		const Inputmask = await loadLib.inputmask();

		for (let i = 1; i <= $selector.length; i++) {
			let mask = $selector[i - 1].dataset.mask,
				format, opts = {};

			switch (mask) {
				case 'phone':
					format = $selector[i - 1].dataset.format || '8 (999) 999-99-99';
					opts = mergeDeepObject({
						clearIncomplete: true,
						showMaskOnHover: true,
						onBeforeMask: function (pastedValue, opts) {
							return _this.normalize_phone(pastedValue)
						},
					}, opts);
					break;
			}

			if (format) {
				let im = new Inputmask(format, opts);
				im.mask($selector[i - 1]);
			}
		}
	},

	normalize_phone: function (val) {
		return val.replace(new RegExp(/\D/, 'g'), '').split('').reverse().slice(0, 10).reverse().join('');
	}
};

function onReady() {
	VGMask.init();
}

document.addEventListener("DOMContentLoaded", onReady);
document.addEventListener("turbo:render", (event) => {
	if (event.target?.hasAttribute('data-turbo-preview') === true) return;
	onReady();
});

export default VGMask;
